import api from "../../../utils/api";

// Create file (multipart/form-data)
export const createFile = async ({ file, entity_type, entity_id }) => {
  if (process.env.NODE_ENV === "development") console.log({ entity_type, entity_id, file });
  if (!file) throw new Error("Missing file");
  if (!entity_type) throw new Error("Missing entity_type for file");
  if (!entity_id) throw new Error("Missing entity_id for file");

  const formData = new FormData();
  formData.append("file", file);
  formData.append("entity_type", entity_type);
  formData.append("entity_id", entity_id);

  const res = await api.post("/files/", formData);
  return res.data;
};

// Read file by ID
export const readFile = async (publicId) => {
  if (!publicId) throw new Error("Missing or invalid ID for file");
  const res = await api.get(`/files/${publicId}`);
  return res.data;
};

// Read list of files
export const readFiles = async (params) => {
  const res = await api.get("/files", params ? { params } : {});
  return res.data;
};

// Delete file
export const deleteFile = async (publicId) => {
  if (process.env.NODE_ENV === "development") console.log(publicId);
  if (!publicId) throw new Error("Invalid ID for file!");
  return await api.delete(`/files/${publicId}`);
};

// Fetch a file and return a blob URL that can be used in <img src> or other elements.
// Caller is responsible for revoking the URL via URL.revokeObjectURL when no longer needed.
export const readFileIntoBlobUrl = async (publicId) => {
  if (!publicId) throw new Error("Invalid ID for file!");
  const res = await api.get(`/files/${encodeURIComponent(publicId)}/file`, {
    responseType: "blob",
  });
  const blobUrl = URL.createObjectURL(res.data);
  return blobUrl;
};

// Download file
export const downloadFile = async (downloadId, displayLabel, openInline = false) => {
  if (!downloadId) throw new Error("Missing downloadId for file");

  try {
    // Fetch the file as a blob
    const response = await api.get(`/files/${encodeURIComponent(downloadId)}/file`, {
      responseType: "blob",
    });

    // Get the content type from response headers
    const contentType = response.headers["content-type"] || "application/octet-stream";

    // Create a blob with proper content type
    const blob = new Blob([response.data], { type: contentType });
    const blobUrl = URL.createObjectURL(blob);

    if (openInline) {
      // Open in new tab to view inline
      window.open(blobUrl, "_blank");
      // Clean up the blob URL after a delay to allow the browser to load it
      setTimeout(() => URL.revokeObjectURL(blobUrl), 2000);
    } else {
      // Force download using anchor tag
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = displayLabel || `attachment_${downloadId}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    }
  } catch (error) {
    throw new Error(`Download failed: ${error?.message || error}`);
  }
};
